import { Col, Form, Row } from 'react-bootstrap';
import Proptypes from 'prop-types';
import DatePicker from 'react-datepicker';
import { useState, useRef, useEffect } from 'react';
import LeftArrow from '~/images/icon/left-arrow.png';
import { getMinutes, getHours } from '@/constant';
import 'react-datepicker/dist/react-datepicker.css';
import PlusIcon from '~/images/icon/square-plus.png';
import CrossIcon from '~/images/icon/cross-gray.png';

export const SingleCalendar = ({ handleChange, handleChangeDateTime, handleCheckboxChange, item, handleAddCalendarSection, handleRemoveCalendarSection, errors, disable }) => {
  const {ci_seminar_flg, ci_seminar_items} = item;
  return (
    <>
      <div className='mb-3'>
        <input
          type='checkbox'
          id='ci_seminar_flg'
          name='ci_seminar_flg'
          value={disable ? disable : 0}
          checked={disable ? disable : 0}
          onChange={handleCheckboxChange}
        />
        <label htmlFor='ci_seminar_flg'>カレンダーに登録する情報の設定</label>
      </div>
      {  
        ci_seminar_items.map((element, index) => (
          <AddSingleCalendar
            key={index}
            handleChange={(event) => handleChange(event, null, null, index)}
            handleChangeDateTime={handleChangeDateTime}
            item={element}
            errors={errors}
            index={index}
            disable={disable}
            ci_seminar_flg={ci_seminar_flg}
            handleRemoveCalendarSection={handleRemoveCalendarSection}
          />
        ))
      }
      {
        ci_seminar_items.length < 10 && (<div className='add-new' onClick={ disable ? handleAddCalendarSection : () => {}}>
          <img className={'img ' + (disable ? '' : 'disabled')} src={PlusIcon} alt='Plus Icon' />
        </div>)
      }
    </>
  );
};


SingleCalendar.prototype = {
  handleChange: Proptypes.func,
  item: Proptypes.object,
  errors: Proptypes.object,
  handleChangeDateTime: Proptypes.func,
  handleCheckboxChange: Proptypes.func,
  handleAddCalendarSection: Proptypes.func,
  handleRemoveCalendarSection: Proptypes.func,
  disable: Proptypes.bool
};

export const AddSingleCalendar = ({ handleChange, handleChangeDateTime, handleRemoveCalendarSection, ci_seminar_flg, item, errors, disable, index}) => {
  const {ci_title, ci_url, ci_address, ci_description, ci_start_date, ci_end_date, ci_start_time, ci_end_time, ci_start_minute, ci_end_minute} = item;
  const refStartTimeList = useRef(null);
  const refEndTimeList = useRef(null);
  const refStartMinutesList = useRef(null);
  const refEndMinutesList = useRef(null);
  const [showStartTime, setShowStartTime] = useState(false);
  const [showEndTime, setShowEndTime] = useState(false);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [showStartMinutes, setShowStartMinutes] = useState(false);
  const [showEndMinutes, setShowEndMinutes] = useState(false);

  useEffect(() => {
    if (ci_start_date) setStartDate(ci_seminar_flg === 0 ? null : new Date(ci_start_date));
    if (ci_end_date) setEndDate(ci_seminar_flg === 0 ? null : new Date(ci_end_date));
  },[ci_start_date, ci_end_date, ci_seminar_flg])

  // Select
  useEffect(() => {
    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);

  const handleClickOutside = (event) => {
    if (refStartTimeList.current && (!refStartTimeList.current.contains(event.target) || event.target.tagName == 'LI')) {
      setShowStartTime(false);
    }
    if (refEndTimeList.current && (!refEndTimeList.current.contains(event.target) || event.target.tagName == 'LI')) {
      setShowEndTime(false);
    }
    // Start minutes
    if (refStartMinutesList.current && (!refStartMinutesList.current.contains(event.target) || event.target.tagName == 'LI')) {
      setShowStartMinutes(false);
    }
    // End minutes
    if (refEndMinutesList.current && (!refEndMinutesList.current.contains(event.target) || event.target.tagName == 'LI')) {
      setShowEndMinutes(false);
    }
  };

  //
  useEffect(() => {
    if (showStartTime || showEndTime || showStartMinutes ||showEndMinutes) {
      setScrollPosition();
    }
  }, [showStartTime, showEndTime, showStartMinutes, showEndMinutes]);

  //
  const setScrollPosition = () => {
    const element = document.getElementById('time0') || document.getElementById('minute0');
    if (element) {
      element.scrollIntoView();
    }
  };
  return (
    <>
      <div className='multi-section-wrapper mb-3'>
        <div className='remove-item remove-calendar'>
          {index > 0 && (<img onClick={() => disable ? handleRemoveCalendarSection(index) : ""} src={CrossIcon} alt='Cross Icon' />)}
        </div>
        <Form.Group as={Row} className='mb-3' controlId={`control_form_seminar_name_${index}`}>
          <Form.Label column sm='3' className='text-center'>
            セミナー名<span className='is-required'>*</span>
          </Form.Label>
          <Col sm='9'>
            <Form.Control
              type='text'
              name='ci_title'
              placeholder={(ci_seminar_flg === 1) ? 'ご記入ください...': '' }
              disabled={!disable}
              value={ci_title ? ci_title : ''}
              onChange={handleChange}
              isInvalid={disable && errors[`ci_title${index}`]}
            />
            <Form.Control.Feedback type='invalid'>{errors[`ci_title${index}`]}</Form.Control.Feedback>
          </Col>
        </Form.Group>

        <Form.Group as={Row} className='mb-3' controlId={`control_form_start_date_time_${index}`}>
          <Form.Label column sm='3' className='text-center'>
            開催日時<span className='is-required'>*</span>
          </Form.Label>
          <Col sm='9'>
            <div className='d-flex align-items-center'>
              <Form.Group className='w-100'>
                <DatePicker
                  autoComplete='off'
                  selected={startDate}
                  id={`control_form_start_date_time_${index}`}
                  disabled={!disable}
                  placeholderText={(ci_seminar_flg === 1) ? '日付を選択': '' }
                  maxDate={new Date('9999-12-31')}
                  dateFormat='yyyy-MM-dd'
                  className={disable && errors[`ci_start_date${index}`] ? 'form-control is-invalid' : 'form-control'}
                  onChange={(date) => {
                    setStartDate(date);
                    handleChangeDateTime('ci_start_date', date, index);
                  }}
                />
              </Form.Group>

              <Form.Group ref={refStartTimeList} className='ms-2 w-80' controlId={`control_start_time_${index}`}>
                <div className='position-relative'>
                  <Form.Control
                    name='ci_start_time'
                    onFocus={(event) => {
                      event.target.select();
                      setShowStartTime(true);
                    }}
                    readOnly
                    type='text'
                    placeholder={(ci_seminar_flg === 1) ? '時間を選択': '' }
                    value={ci_start_time ? `${ci_start_time}時` : ''}
                    maxLength={2}
                    disabled={!disable}
                    isInvalid={disable && errors[`ci_start_time${index}`]}
                  />

                  {/* Arrow icon */}
                  <div className='select-carret'>
                    <img src={LeftArrow} alt='Left arrow' />
                  </div>

                  {/* Time list shown here */}
                  {showStartTime && (
                    <ul className='time-list'>
                      {getHours()?.map((option, idx) => (
                        <li
                          key={idx}
                          className='time'
                          onClick={() => {
                            handleChangeDateTime('ci_start_time', option, index);
                          }}
                          id={`time${idx}`}>
                          {option+'時'}
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              </Form.Group>
              <Form.Group ref={refStartMinutesList} className='ms-2 w-70' controlId={`startMinute_${index}`}>
                <div className='position-relative'>
                  <Form.Control
                    name='ci_start_minute'
                    onFocus={(event) => {
                      event.target.select();
                      setShowStartMinutes(true);
                    }}
                    readOnly
                    type='text'
                    placeholder={(ci_seminar_flg === 1) ? '分を選択': '' }
                    value={ci_start_minute ? `${ci_start_minute}分` : ''}
                    maxLength={2}
                    disabled={!disable}
                    isInvalid={disable && errors[`ci_start_minute${index}`]}
                  />

                  {/* Arrow icon */}
                  <div className='select-carret'>
                    <img src={LeftArrow} alt='Left arrow' />
                  </div>

                  {/* Time list shown here */}
                  {showStartMinutes && (
                    <ul className='time-list'>
                      {getMinutes()?.map((option, idx) => (
                        <li
                          key={idx}
                          className='time'
                          onClick={() => {
                            handleChangeDateTime('ci_start_minute', option, index);
                          }}
                          id={`minute${idx}`}>
                          {option+'分'}
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              </Form.Group>
            </div>
            {(disable !== 0) && (
              <div className='w-100'>
                <Form.Control.Feedback type='invalid' className={errors[`ci_start_date${index}`] ? 'd-block' : ''}>
                  {errors[`ci_start_date${index}`]}
                </Form.Control.Feedback>
                <Form.Control.Feedback type='invalid' className={errors[`ci_start_time${index}`] ? 'd-block' : ''}>
                  {(errors[`ci_start_time${index}`] || errors[`ci_start_minute${index}`])}
                </Form.Control.Feedback>
                <Form.Control.Feedback type='invalid' className={errors[`ci_start_minute${index}`] ? 'd-block' : ''}>
                  {errors[`ci_start_minute${index}`]}
                </Form.Control.Feedback>
              </div>
            )}
          </Col>
        </Form.Group>

        <Form.Group as={Row} className='mb-3' controlId={`control_form_end_date_time_${index}`}>
          <Form.Label column sm='3' className='text-center'>
            終了日時<span className='is-required'>*</span>
          </Form.Label>
          <Col sm='9'>
            <div className='d-flex align-items-center'>
              <Form.Group className='w-100'>
                <DatePicker
                  autoComplete='off'
                  name='ci_end_date'
                  id={`control_form_end_date_time_${index}`}
                  selected={endDate}
                  disabled={!disable}
                  placeholderText={(ci_seminar_flg === 1) ? '日付を選択': '' }
                  maxDate={new Date('9999-12-31')}
                  dateFormat='yyyy-MM-dd'
                  className={disable && (errors[`ci_end_date${index}`] || errors[`ci_date_time_laterthan${index}`]) ? 'form-control is-invalid' : 'form-control'}
                  onChange={(date) => {
                    setEndDate(date);
                    handleChangeDateTime('ci_end_date', date, index);
                  }}
                />
                <Form.Control.Feedback type='invalid'>{errors[`ci_end_date${index}`]}</Form.Control.Feedback>
              </Form.Group>
              <Form.Group ref={refEndTimeList} className='ms-2 w-80' controlId={`end_time_${index}`}>
                <div className='position-relative'>
                  <Form.Control
                    name='ci_end_time'
                    onFocus={(event) => {
                      event.target.select();
                      setShowEndTime(true);
                    }}
                    readOnly
                    type='text'
                    placeholder={(ci_seminar_flg === 1) ? '時間を選択': '' }
                    value={ci_end_time ? `${ci_end_time}時` : ''}
                    maxLength={2}
                    disabled={!disable}
                    isInvalid={disable && (errors[`ci_end_time${index}`] || errors[`ci_date_time_laterthan${index}`])}
                  />

                  {/* Arrow icon */}
                  <div className='select-carret'>
                    <img src={LeftArrow} alt='Left arrow' />
                  </div>

                  {/* Time list shown here */}
                  {showEndTime && (
                    <ul className='time-list'>
                      {getHours()?.map((option, idx) => (
                        <li
                          key={idx}
                          className='time'
                          onClick={() => {
                            handleChangeDateTime('ci_end_time', option, index);
                          }}
                          id={`time${idx}`}>
                          {option+'時'}
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
                <Form.Control.Feedback type='invalid'>{errors[`end_time${index}`]}</Form.Control.Feedback>
              </Form.Group>
              <Form.Group ref={refEndMinutesList} className='ms-2 w-70' controlId={`endMinute_${index}`}>
                <div className='position-relative'>
                  <Form.Control
                    name='ci_end_minute'
                    onFocus={(event) => {
                      event.target.select();
                      setShowEndMinutes(true);
                    }}
                    readOnly
                    type='text'
                    placeholder={(ci_seminar_flg === 1) ? '分を選択': '' }
                    value={ci_end_minute ? `${ci_end_minute}分` : ''}
                    maxLength={2}
                    disabled={!disable}
                    isInvalid={disable && (errors[`ci_end_minute${index}`] || errors[`ci_date_time_laterthan${index}`])}
                  />

                  {/* Arrow icon */}
                  <div className='select-carret'>
                    <img src={LeftArrow} alt='Left arrow' />
                  </div>

                  {/* Time list shown here */}
                  {showEndMinutes && (
                    <ul className='time-list'>
                      {getMinutes()?.map((option, idx) => (
                        <li
                          key={idx}
                          className='time'
                          onClick={() => {
                            handleChangeDateTime('ci_end_minute', option, index);
                          }}
                          id={`minute${idx}`}>
                          {option+'分'}
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              </Form.Group>
            </div>
            {(disable !== 0) && (
              <div className='w-100'>
                <Form.Control.Feedback type='invalid' className={errors[`ci_end_date${index}`] ? 'd-block' : ''}>
                  {errors[`ci_end_date${index}`]}
                </Form.Control.Feedback>
                <Form.Control.Feedback type='invalid' className={errors[`ci_end_time${index}`] ? 'd-block' : ''}>
                  {errors[`ci_end_time${index}`]}
                </Form.Control.Feedback>
                <Form.Control.Feedback type='invalid' className={errors[`ci_end_minute${index}`] ? 'd-block' : ''}>
                  {errors[`ci_end_minute${index}`]}
                </Form.Control.Feedback>
                <Form.Control.Feedback type='invalid' className={errors[`ci_date_time_laterthan${index}`] ? 'd-block' : ''}>
                  {errors[`ci_date_time_laterthan${index}`]}
                </Form.Control.Feedback>
              </div>
            )}
          </Col>
        </Form.Group>

        <Form.Group as={Row} className='mb-3' controlId={`control_form_ci_description_${index}`}>
          <Form.Label column sm='3' className='text-center'>
            セミナー内容<span className='is-required'>*</span>
          </Form.Label>
          <Col sm='9'>
            <Form.Control
              type='text'
              name='ci_description'
              placeholder={(ci_seminar_flg === 1) ? 'ご記入ください...': '' }
              isInvalid={disable && errors[`ci_description${index}`]}
              disabled={!disable}
              value={ci_description ? ci_description : ''}
              onChange={handleChange}
            />
            <Form.Control.Feedback type='invalid'>{errors[`ci_description${index}`]}</Form.Control.Feedback>
          </Col>
        </Form.Group>

        <Form.Group as={Row} className='mb-3' controlId={`Formci_address_${index}`}>
          <Form.Label column sm='3' className='text-center'>
            開催場所<span className='is-required'>*</span>
          </Form.Label>
          <Col sm='9'>
            <Form.Control
              isInvalid={disable && errors[`ci_address${index}`]}
              type='text'
              name='ci_address'
              placeholder={(ci_seminar_flg === 1) ? 'ご記入ください...': '' }
              disabled={!disable}
              value={ci_address ? ci_address : ''}
              onChange={handleChange}
            />
            <Form.Control.Feedback type='invalid'>{errors[`ci_address${index}`]}</Form.Control.Feedback>
          </Col>
        </Form.Group>

        <Form.Group as={Row} className='mb-3' controlId={`FormUrl_${index}`}>
          <Form.Label column sm='3' className='text-center'>
          URL（任意）
          </Form.Label>
          <Col sm='9'>
            <Form.Control
              isInvalid={disable && errors[`ci_url${index}`]}
              type='text'
              name='ci_url'
              placeholder={(ci_seminar_flg === 1) ? 'ご記入ください...': '' }
              disabled={!disable}
              value={ci_url ? ci_url : ''}
              onChange={handleChange}
            />
            <Form.Control.Feedback type='invalid'>{errors[`ci_url${index}`]}</Form.Control.Feedback>
          </Col>
        </Form.Group>
      </div>
    </>
  );
};


AddSingleCalendar.prototype = {
  handleChange: Proptypes.func,
  item: Proptypes.object,
  errors: Proptypes.object,
  handleChangeDateTime: Proptypes.func,
  handleRemoveCalendarSection: Proptypes.func,
  disable: Proptypes.bool,
  index: Proptypes.number,
  ci_seminar_flg: Proptypes.number,
};